module.exports = __webpack_public_path__ + "assets/img/btn-view-15d0e598.png";